const grey500 = '#94A6B8';

export const reactSelectStyles = {
  container: base => ({
    ...base,
    height: 'auto',
    width: '100%',
    boxShadow: 'none'
  }),
  control: (base, props) => ({
    ...base,
    borderColor: grey500,
    borderRadius: '0px',
    borderWidth: props?.selectProps.disabled ? '0px' : '1px',
    minHeight: 48,
    height: '48px',
    '&:hover': { borderColor: grey500 },
    boxShadow: 'none',
    pointerEvents: props?.selectProps.disabled ? 'none' : 'auto'
  }),
  indicatorSeparator: base => ({
    ...base,
    display: 'none'
  }),
  dropdownIndicator: (base, props) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
    display:
      props?.selectProps?.hideDropdownIndicator || props?.selectProps?.disabled
        ? 'none'
        : base.display
  }),
  placeholder: base => ({
    ...base,
    color: grey500,
    margin: 0
  }),
  input: base => ({
    ...base,
    marginLeft: 0
  }),
  menu: base => ({
    ...base,
    zIndex: 10
  }),
  valueContainer: (base, props) => ({
    ...base,
    padding: props?.selectProps?.disabled ? '0' : '2px 8px'
  })
};
